import { configureStore } from '@reduxjs/toolkit'
//import { rootReducer } from 'src/reducers/configureStore'
import cornealSlice from 'src/actions/simulationAdaptation/cornealSlice'

const store = configureStore({
  reducer: {
    corneal: cornealSlice.reducer,
  },
})

export type RootState = ReturnType<typeof store.getState>

export default store
